<script setup lang="ts">
import { getTranslations } from '@/lib/util/i18n';
import { secondsToDateObject, isoDateToDateObject } from '@/lib/util/dateTime';
import EditShiftForm from './EditShiftForm.vue';
import { useTimesheetStore } from '@/stores/timesheets';

const timesheets = useTimesheetStore();

const MILLISECONDS_IN_SECOND = 1000;

const t = getTranslations({
  app: '',
  module: 'views',
  file: 'edit-shift-time',
});

const endTimeObject = secondsToDateObject(Date.now() / MILLISECONDS_IN_SECOND);
const startTimeObject = isoDateToDateObject(timesheets.getStartShiftTime());

function updateShift(shiftStartTime?: string, shiftEndTime?: string) {
  emit('updateShift', shiftStartTime, shiftEndTime);
}

const emit = defineEmits<{
  (e: 'updateShift', shiftStartTime?: string, shiftEndTime?: string): void;
}>();
</script>

<template>
  <EditShiftForm
    :first-time="startTimeObject"
    :second-time="endTimeObject"
    :label="t('label')"
    :secondLabel="t('second-label')"
    :placeholder="t('placeholder')"
    :secondPlaceholder="t('second-label')"
    :shiftOverlapWarning="t('shift-warning')"
    :breakOverlapWarning="t('break-warning')"
    :edit-shift-time="true"
    @updateShift="updateShift"
  ></EditShiftForm>
</template>
